/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export enum AuthOptionType {
  Default = "DEFAULT",
  None = "NONE",
  Signin = "SIGNIN",
  SigninSignup = "SIGNIN_SIGNUP",
}
